// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__38CQ3","log":"ModalInventoryLogs_log__1lyp2","date":"ModalInventoryLogs_date__3HY48","userName":"ModalInventoryLogs_userName__2lCqc"};